"use strict";
module.exports = process.env.npm_package_version;
//# sourceMappingURL=package_version_browser.js.map